import React, { memo } from "react";
import { Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import RequiredTitle from "./RequiredTitle";

const TimePickerField = ({ input, control, error, defaultValue }) => {
  const {
    name,
    type,
    label,
    validation,
    alignment = {},
    defaultValues = defaultValue,
    ...rest
  } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <Controller
        name={name}
        control={control}
        rules={validation}
        defaultValue={defaultValues}
        render={({ field }) => (
          <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box>
                <TimePicker
                  value={
                    (() => {
                      if (!field.value) return null;
                      
                      if (typeof field.value === 'string' && field.value.includes(':')) {
                        const timeValue = new Date(`2000-01-01T${field.value}`);
                        return timeValue;
                      }
                      
                      if (isValid(parseISO(field.value))) {
                        const parsedValue = parseISO(field.value);
                        return parsedValue;
                      }
                      
                      return field.value;
                    })()
                  }
                  onChange={(time) => {
                    if (time && isValid(time)) {
                      const formatted = format(time, "HH:mm:ss");
                      field.onChange(formatted);
                    } else {
                      field.onChange(null);
                    }
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      placeholder: "Select time"
                    }
                  }}
                  {...rest}
                />
              </Box>
            </LocalizationProvider>
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
        )}
      />
    </div>
  );
};

export default memo(TimePickerField);
